import { RentEntity } from 'backend-entity';

export type CrmPatchRentRequestDto = Partial<Pick<RentEntity, 'startDate' | 'price' | 'status'>>;
